import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router'

import { useInitData } from '../../../hooks'
import { withRentalPortalMockSections } from '../../../utils/rentalPortalMock'
import { Accordion, AccordionItem } from '../../Accordion'
import {
  SubMenuAccordionButton,
  SubMenuList,
  SubMenuWrapper,
} from '../../SubMenu'
import {
  QA_NAME_RENTAL_PORTAL_SUB_MENU,
  QA_NAME_RENTAL_PORTAL_SUB_MENU_SETTINGS,
} from '../RentalPortal.constants'
import {
  getHasRentalPortalSettingsSubsections,
  getIsRentalPortalSubsectionActive,
  getRentalPortalSectionSubsections,
  getRentalPortalSettingsSubsections,
  getRentalPortalSubsectionByPathname,
  getRentalPortalSubsectionLink,
  getRentalPortalViewableSubsections,
} from '../RentalPortal.utils'

import * as styles from './RentalPortalSubMenu.module.css'

function RentalPortalSubMenu({ menuTitle, show: isVisible }) {
  const { t } = useTranslation()

  const { pathname } = useLocation()
  const navigate = useNavigate()

  const { sections } = useInitData()

  const subsections = getRentalPortalViewableSubsections(
    withRentalPortalMockSections(sections)
  )

  const settingsSubsections = getRentalPortalSettingsSubsections(subsections)

  function handleClickSubsection(subsectionName) {
    navigate(getRentalPortalSubsectionLink(subsectionName))
  }

  const activeSubsection = getRentalPortalSubsectionByPathname(pathname)

  function isActiveSubsection(subsection) {
    return getIsRentalPortalSubsectionActive({ activeSubsection, subsection })
  }

  return isVisible ? (
    <SubMenuWrapper
      className={styles.RentalPortalSubMenu}
      qaName={QA_NAME_RENTAL_PORTAL_SUB_MENU}
    >
      <span className={styles.subTitle}>{menuTitle}</span>
      <SubMenuList
        className={styles.list}
        isActive={isActiveSubsection}
        items={getRentalPortalSectionSubsections(subsections)}
        onClickItem={handleClickSubsection}
      />
      {getHasRentalPortalSettingsSubsections(settingsSubsections) ? (
        <div className={styles.settings}>
          <Accordion
            variant
            ButtonComponent={SubMenuAccordionButton}
            itemClassName={styles.settingsItem}
          >
            <AccordionItem
              accordionTitle={t('RentalPortal.SettingsTitleKey')}
              initOpen={settingsSubsections.some(isActiveSubsection)}
              qaName={QA_NAME_RENTAL_PORTAL_SUB_MENU_SETTINGS}
            >
              <SubMenuList
                className={styles.settingsList}
                isActive={isActiveSubsection}
                items={settingsSubsections}
                onClickItem={handleClickSubsection}
              />
            </AccordionItem>
          </Accordion>
        </div>
      ) : null}
    </SubMenuWrapper>
  ) : null
}

export default RentalPortalSubMenu
